import TyFooterOneButton from './TyFooterOneButton.vue'
export default TyFooterOneButton



// WEBPACK FOOTER //
// ./src/components/ty-footer-one-button/index.js